import { SiStyledcomponents, SiReact, SiCss3 } from 'react-icons/si';

import LalaWebsiteProject from '../../Components/Images/LalaWebsiteProject.png';
import ChangeAgentProject from '../../Components/Images/ChangeAgentProject.png';
import FoodieProject from '../../Components/Images/FoddieProject.png';

const techs = [
  { name: 'React ', logo: <SiReact /> },
  { name: 'Styled Components', logo: <SiStyledcomponents /> },
  { name: 'CSS', logo: <SiCss3 /> },
];

export const projectsPortfolio = [
  {
    title: ' Change Agent ',
    image: ChangeAgentProject,
    techs,
    description: 'Website created with React JS and Styled Components.',
    repository: 'https://github.com/Itzabelli/ChangeAgent.git',
    website: 'https://change-agent.netlify.app/',
  },
  {
    title: 'Lala`s Desserts',
    image: LalaWebsiteProject,
    techs,
    description: 'Website created with React JS and Styled Components.',
    repository: 'https://github.com/Itzabelli/Lala-Website.git',
    website: 'lalas-website.netlify.app',
  },
  {
    title: 'Foodie Website',
    image: FoodieProject,
    techs,
    description: 'Website created with React JS and Styled Components.',
    repository: 'https://github.com/Itzabelli/foodie.git',
    website: 'https://itzabelli.github.io/foodie/',
  },
  {
    title: 'Canasta de Oriana',
    image: ChangeAgentProject,
    techs,
    description: 'Website created with React JS and Styled Components.',
    repository: 'https://github.com/Itzabelli/ChangeAgent.git',
    website: '#!',
  },
  {
    title: 'Task List',
    image: LalaWebsiteProject,
    techs,
    description: 'Website created with React JS and Styled Components.',
    repository: 'https://github.com/Itzabelli/Lala-Website.git',
    website: '#!',
  },
  {
    title: 'Movie App',
    image: FoodieProject,
    techs,
    description: 'Website created with React JS and Styled Components.',
    repository: 'https://github.com/Itzabelli/foodie.git',
    website: '#!',
  },
];
